import { css } from '@emotion/css';

const assumeRoleInstructionsStyle = css({
  maxWidth: "715px"
});

export { assumeRoleInstructionsStyle };
//# sourceMappingURL=ConnectionConfig.styles.js.map
